<template>
  <div class="dashboard-tabs dashboard-tabs--fixed">
    <div v-for="tab in tabs" :key="tab.tabID" class="dashboard-tab dashboard-tab--fixed" :class="{active: activeTab === tab.tabID}"
         @click="$emit('toggletab', tab.tabID)">
      <svg class="dashboard-tab-bg" width="256" height="67"><use xlink:href="#tabs-bg"></use></svg>
      <div class="dashboard-tab-title">
        <svg class="dashboard-tab-icon" width="24" height="24"><use :xlink:href="tab.tabIcon"></use></svg>
        {{tab.tabTitle}}
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'DashboardTabs',
  props: ['activeTab'],
  data: function() {
    return {
      tabs: [
        {
          tabID: 'profilesTab',
          tabIcon: '#icon-kid',
          tabTitle: this.$lang.messages.dashboard.tabs.kids
        },
        {
          tabID: 'devicesTab',
          tabIcon: '#icon-device',
          tabTitle: this.$lang.messages.dashboard.tabs.devices
        }
      ]
    }
  },
  methods: {

  }
}

</script>